export default __webpack_public_path__ + "static/Rui-Tang-Resume-Web-Developer-317c29da05dbb55e7a819b493d6ba648.pdf";